import { NotificationInput } from "../../../__generated__/gql-types/globalTypes";

export const initialValuesObj: NotificationInput = {
  media: "",
  message: "",
  role: "",
  fileId: "",
  school_id: null,
  title: "",
};